/** Compare two inv profile detail / service rows for billing-profiles display order. */
export function compareInvProfileServiceDisplayOrder(a, b) {
  const aSeq = Number(a.sequenceDisplay);
  const bSeq = Number(b.sequenceDisplay);
  const aHasSeq = Number.isFinite(aSeq);
  const bHasSeq = Number.isFinite(bSeq);
  if (aHasSeq && bHasSeq && aSeq !== bSeq) {
    return aSeq - bSeq;
  }
  if (aHasSeq !== bHasSeq) {
    return aHasSeq ? -1 : 1;
  }
  const aId = Number(a.invProfileDetailId ?? a.id);
  const bId = Number(b.invProfileDetailId ?? b.id);
  if (Number.isFinite(aId) && Number.isFinite(bId) && aId !== bId) {
    return bId - aId;
  }
  return 0;
}

/** Saved profile services ordered by sequence_display, then newest inv_profile_detail_id. */
export function sortSavedProfileServicesNewestFirst(services) {
  return [...(services ?? [])].sort(compareInvProfileServiceDisplayOrder);
}

export function filterProfileDetailsForInvProfile(profileDetails, invProfileId) {
  const profileId = Number(invProfileId);
  if (!Number.isFinite(profileId) || profileId <= 0) {
    return profileDetails ?? [];
  }
  return (profileDetails ?? []).filter(
    (detail) => Number(detail.invProfileId) === profileId
  );
}

export function resolveLineInvProfileDetailId(line) {
  const id = Number(line?.invProfileDetailId ?? line?.inv_profile_detail_id);
  return Number.isFinite(id) && id > 0 ? id : null;
}

/**
 * Sort invoice/draft lines to match billing profile services order.
 * Profile-backed lines use sequence_display + inv_profile_detail_id.
 * Lines without a matching profile detail stay at the end in relative order.
 */
export function sortInvoiceLinesByProfileServiceOrder(lines, profileDetails, invProfileId) {
  const filteredDetails = filterProfileDetailsForInvProfile(profileDetails, invProfileId);
  const detailById = new Map();
  for (const detail of filteredDetails) {
    const id = Number(detail.invProfileDetailId);
    if (Number.isFinite(id) && id > 0) {
      detailById.set(id, detail);
    }
  }

  const indexed = (lines ?? []).map((line, index) => ({ line, index }));
  return indexed
    .sort((a, b) => {
      const detailA = detailById.get(resolveLineInvProfileDetailId(a.line));
      const detailB = detailById.get(resolveLineInvProfileDetailId(b.line));
      if (detailA && detailB) {
        return compareInvProfileServiceDisplayOrder(detailA, detailB);
      }
      if (detailA && !detailB) {
        return -1;
      }
      if (!detailA && detailB) {
        return 1;
      }
      return a.index - b.index;
    })
    .map((entry) => entry.line);
}
